import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  LanguageService,
  OccEndpointsService,
  RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { filter, map, Observable, Subscription } from 'rxjs';
import { CustomInfluenzaService } from '../custom-influenza.service';
import { FLU_CHECKOUT_TYPE } from 'src/app/shared/model/flu.model';
import { SharedService } from 'src/app/shared/services/shared.service';
import { LocationStripService } from 'src/app/shared/modules/location-strip/location-strip.service';
import {
  ACTIVE_SEASONS,
  MIN_DOSES_THRESHOLD,
  OLD_QUOTE_CODE,
  ORIGINAL_ORDER_CODE,
  UserUtils,
} from 'src/app/shared';
import { WholesalerPharmacyService } from '../wholesaler-pharmacy';
@Component({
  selector: 'app-influenza-dashboard-footer',
  templateUrl: './influenza-dashboard-footer.component.html',
  styleUrls: ['./influenza-dashboard-footer.component.scss'],
})
export class InfluenzaDashboardFooterComponent implements OnInit, OnDestroy {
  userData: any = [];
  activeSeasons$: Observable<any[]> = this.influenzaService.activeSeasons?.pipe(
    filter(Boolean),
    map((activeSeasons) => {
      return activeSeasons.map((season) => ({
        ...season,
        isInPreorder:
          new Date() >= new Date(season.startDate) &&
          new Date() <= new Date(season.endDate),
      }));
    })
  );
  productList = [];
  editNotClicked = true;
  saveClicked = false;
  compName = 'SanofiFluDashboardBannerComponent';

  preferredContact = '';
  baseUrl: any;
  fname: any;
  screenwidth: any;
  fallbackImage = '../../assets/i18n-assets/sanofiwebb_missing_product.png';
  addClicked: boolean;

  subscription = new Subscription();
  modalSubscription = new Subscription();
  isPharmacyUser$ = this.user.get().pipe(map(UserUtils.isPharmacyUser));
  fluCheckoutType$ = this.influenzaService.getFluCheckoutType();
  FLU_CHECKOUT_TYPE = FLU_CHECKOUT_TYPE;
  infContacts$ = this.locStrip.userAccountData.pipe(
    map((res) =>
      res?.influenzaContactInfos?.length ? res?.influenzaContactInfos : null
    )
  );
  isDirectUser$ = this.user.get().pipe(map(UserUtils.isDirectUser));

  constructor(
    protected influenzaService: CustomInfluenzaService,
    protected user: UserAccountFacade,
    protected ref: ChangeDetectorRef,
    protected occEndPoint: OccEndpointsService,
    protected router: RoutingService,
    protected modalService: NgbModal,
    protected lang: LanguageService,
    protected sharedService: SharedService,
    protected locStrip: LocationStripService,
    protected wholeSalerPharmacyService: WholesalerPharmacyService
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.user.get().subscribe((res) => {
        if (res) {
          this.userData = res;
          this.influenzaService.getActiveSeasonsFromDb(this.userData.userName);
        }
      })
    );
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.modalSubscription?.unsubscribe();
  }

  onReserve(season: string, callback = () => {}) {
    this.proceedToNextStep(season, callback);
  }

  onReservePBI(season: string) {
    this.onReserve(season, () =>
      this.sharedService.setSessionStorage('PBI', true)
    );
  }

  proceedToNextStep(season: string, callback = () => {}) {
    this.sharedService.setSessionStorage(ACTIVE_SEASONS, season);
    this.sharedService.setSessionStorage('PBI', false);
    this.sharedService.removeSessionStorage(OLD_QUOTE_CODE);
    this.sharedService.removeSessionStorage(MIN_DOSES_THRESHOLD);
    this.sharedService.removeSessionStorage(ORIGINAL_ORDER_CODE);
    callback();
    this.router.goByUrl('/influenza/category');
  }
}
